import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import _get from 'lodash/get';
import { ActionName } from '../../components/RecaptchaProvider/RecaptchaProvider.constants';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../modules/analytics/components/Event';
import ContactForm from '../../organisms/ContactForm';
var defaultProps = {
  centered: false,
  fluidButton: false,
  header: '',
  placeholder: 'youremail@provider.com',
  subheader: '',
  button: true
};
export default function Subscribe(_ref) {
  var businessId = _ref.businessId,
    businessType = _ref.businessType,
    locationId = _ref.locationId,
    fluidButton = _ref.fluidButton,
    placeholder = _ref.placeholder,
    header = _ref.header,
    subheader = _ref.subheader,
    onSubmit = _ref.onSubmit,
    centered = _ref.centered,
    button = _ref.button;
  function submitHandler(_x) {
    return _submitHandler.apply(this, arguments);
  }
  function _submitHandler() {
    _submitHandler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var recaptchaToken, email, action, errorCode;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            recaptchaToken = _ref2.recaptchaToken, email = _ref2.email, action = _ref2.action;
            _context.prev = 1;
            _context.next = 4;
            return onSubmit(businessId, businessType, locationId, recaptchaToken, {
              email: email,
              action: action
            });
          case 4:
            _context.next = 12;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            errorCode = _get(_context.t0, 'response.status');
            if (!(errorCode === 409)) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return");
          case 11:
            throw _context.t0;
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 6]]);
    }));
    return _submitHandler.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(ContactForm, {
    onSubmit: submitHandler,
    fluidButton: fluidButton,
    button: button,
    centeredHeaders: centered,
    fields: [{
      label: 'email',
      placeholder: placeholder,
      type: 'input',
      inputType: 'email',
      required: true
    }],
    header: header,
    subheader: subheader,
    buttonText: "Subscribe",
    locationId: locationId,
    businessId: businessId,
    businessType: businessType,
    successMessage: "Successfully subscribed!",
    event: {
      category: EVENT_CATEGORIES.NEWSLETTER_EVENT_CATEGORY,
      action: EVENT_ACTIONS.NEWSLETTER_SIGNUP_EVENT_ACTION
    },
    recaptchaAction: ActionName.SUBMIT_SUBSCRIBE_FORM
  });
}
Subscribe.defaultProps = defaultProps;